export default class InvisibleRecaptcha {

    static init() {
        window.initRecaptcha = function () {
            InvisibleRecaptcha.callbackInit();
            InvisibleRecaptcha.wishesInit();
            InvisibleRecaptcha.contactInit();
            InvisibleRecaptcha.watchdogInit();
            InvisibleRecaptcha.forgotPasswordInit();
            InvisibleRecaptcha.fastRegistrationInit();
            InvisibleRecaptcha.questionInit();
            InvisibleRecaptcha.wholesaleInit();
            InvisibleRecaptcha.questionModalInit();
        }
        window.submitCallback = function () {
            InvisibleRecaptcha.submitCallback();
        }
        window.submitWishes = function () {
            InvisibleRecaptcha.submitWishes();
        }
        window.submitContact = function () {
            InvisibleRecaptcha.submitContact();
        }
        window.submitWatchdog = function () {
            InvisibleRecaptcha.submitWatchdog();
        }
        window.submitForgotPassword = function () {
            InvisibleRecaptcha.submitForgotPassword();
        }
        window.submitFastRegistration = function () {
            InvisibleRecaptcha.submitFastRegistration();
        }
        window.submitQuestion = function () {
            InvisibleRecaptcha.submitQuestion();
        }
        window.submitWholesale = function() {
            InvisibleRecaptcha.submitWholesale();
        }
        window.submitModalQuestion = function() {
            InvisibleRecaptcha.submitModalQuestion();
        }
    }

    static questionModalInit() {
        const element = document.getElementById('modalQuestionFormSubmit');
        const captchaElement = document.getElementById('questionModalRecaptcha');
        if (element) {
            let l = null;
            grecaptcha.ready(function () {
                l = grecaptcha.render(captchaElement, {
                    'callback': captchaElement.dataset.callback,
                    'siteKey': captchaElement.dataset.siteKey
                });
            });

            element.onclick = function (e) {
                e.preventDefault();
                const form = document.getElementById('frm-questionFormModal-form');
                if (Nette.validateForm(form)) {
                    grecaptcha.execute(l);
                }
            }
        }
    }

    static submitModalQuestion() {
        const form = document.getElementById('frm-questionFormModal-form');
        if (form && Nette.validateForm(form)) {
            form.submit();
        }
    }

    static wholesaleInit() {
        const element = document.getElementById('wholesaleSubmit');
        const captchaElement = document.getElementById('wholesaleCaptcha');
        if (element) {
            let l = null;
            grecaptcha.ready(function () {
                l = grecaptcha.render(captchaElement, {
                    'callback': captchaElement.dataset.callback,
                    'siteKey': captchaElement.dataset.siteKey
                });
            });

            element.onclick = function (e) {
                e.preventDefault();
                const form = document.getElementById('frm-wholesaleRegistrationForm-form');
                if (Nette.validateForm(form)) {
                    grecaptcha.execute(l);
                }
            }
        }
    }

    static submitWholesale() {
        const form = document.getElementById('frm-wholesaleRegistrationForm-form');
        if (form && Nette.validateForm(form)) {
            form.submit();
        }
    }

    static callbackInit() {
        const element = document.getElementById('callbackSubmit');
        const captchaElement = document.getElementById('callbackCaptcha');
        if (element) {
            let l = null;
            grecaptcha.ready(function () {
                l = grecaptcha.render(captchaElement, {
                    'callback': captchaElement.dataset.callback,
                    'siteKey': captchaElement.dataset.siteKey
                });
            });

            element.onclick = function (e) {
                e.preventDefault();
                const form = document.getElementById('frm-callbackForm-form');
                if (Nette.validateForm(form)) {
                    grecaptcha.execute(l);
                }
            }
        }
    }

    static submitCallback() {
        const form = document.getElementById('frm-callbackForm-form');
        if (form && Nette.validateForm(form)) {
            form.submit();
        }
    }

    static wishesInit() {
        const element = document.getElementById('wishesSubmit');
        const captchaElement = document.getElementById('wishesRecaptcha')
        if (element) {
            let l = null;
            grecaptcha.ready(function () {
                l = grecaptcha.render(captchaElement, {
                    'callback': captchaElement.dataset.callback,
                    'siteKey': captchaElement.dataset.siteKey
                });
            });
            element.onclick = function (e) {
                e.preventDefault();
                const form = document.getElementById('frm-productEmailWishesForm-form');
                if (Nette.validateForm(form)) {
                    grecaptcha.execute(l);
                }
            }
        }
    }

    static submitWishes() {
        console.log('wishesSubmit');
        const form = document.getElementById('frm-productEmailWishesForm-form');
        if (form && Nette.validateForm(form[0])) {
            form.submit();
        }
    }

    static contactInit() {
        const element = document.getElementById('contactSubmit');
        const captchaElement = document.getElementById('contactRecaptcha');
        if (element) {
            let l = null;
            grecaptcha.ready(function () {
                l = grecaptcha.render(captchaElement, {
                    'callback': captchaElement.dataset.callback,
                    'siteKey': captchaElement.dataset.siteKey
                });
            });
            element.onclick = function (e) {
                e.preventDefault();
                const form = document.getElementById('frm-contactForm-form');
                if (Nette.validateForm(form)) {
                    grecaptcha.execute(0);
                }
            }
        }
    }

    static submitContact() {
        const form = document.getElementById('frm-contactForm-form');
        if (form && Nette.validateForm(form[0])) {
            form.submit();
        }
    }

    static watchdogInit() {
        const element = document.getElementById('watchdogSubmit');
        const captchaElement = document.getElementById('watchdogRecaptcha');
        if (element) {
            let l = null;
            grecaptcha.ready(function () {
                l = grecaptcha.render(captchaElement, {
                    'callback': captchaElement.dataset.callback,
                    'siteKey': captchaElement.dataset.siteKey
                });
            });
            element.onclick = function (e) {
                e.preventDefault();
                const form = document.getElementById('frm-productWatchdogForm-form');
                if (Nette.validateForm(form)) {
                    grecaptcha.execute(l);
                }
            }
        }
    }

    static submitWatchdog() {
        const form = document.getElementById('frm-productWatchdogForm-form');
        if (form && Nette.validateForm(form[0])) {
            form.submit();
        }
    }

    static forgotPasswordInit() {
        const element = document.getElementById('forgotPasswordSubmit');
        const captchaElement = document.getElementById('forgotPasswordRecaptcha');
        if (element) {
            let l = null;
            grecaptcha.ready(function () {
                l = grecaptcha.render(captchaElement, {
                    'callback': captchaElement.dataset.callback,
                    'siteKey': captchaElement.dataset.siteKey
                });
            });
            element.onclick = function (e) {
                e.preventDefault();
                const form = document.getElementById('frm-forgotPasswordRequestForm-form');
                if (Nette.validateForm(form)) {
                    grecaptcha.execute(l);
                }
            }
        }
    }

    static submitForgotPassword() {
        const form = document.getElementById('frm-forgotPasswordRequestForm-form');
        if (form && Nette.validateForm(form[0])) {
            form.submit();
        }
    }

    static fastRegistrationInit() {
        const element = document.getElementById('submitFastRegistration');
        const captchaElement = document.getElementById('fastRegistrationRecaptcha');
        if (element) {
            let l = null;
            grecaptcha.ready(function () {
                l = grecaptcha.render(captchaElement, {
                    'callback': captchaElement.dataset.callback,
                    'siteKey': captchaElement.dataset.siteKey
                });
            });
            element.onclick = function (e) {
                e.preventDefault();
                const form = document.getElementById('frm-fastRegistrationPersonForm-fastRegistrationPersonForm');
                if (Nette.validateForm(form)) {
                    grecaptcha.execute(l);
                }
            }
        }
    }

    static submitFastRegistration() {
        const form = document.getElementById('frm-fastRegistrationPersonForm-fastRegistrationPersonForm');
        if (form && Nette.validateForm(form[0])) {
            form.submit();
        }
    }

    static questionInit() {
        const element = document.getElementById('submitQuestion');
        const captchaElement = document.getElementById('questionRecaptcha');
        if (element) {
            let l = null;
            grecaptcha.ready(function () {
                l = grecaptcha.render(captchaElement, {
                    'callback': captchaElement.dataset.callback,
                    'siteKey': captchaElement.dataset.siteKey
                });
            });
            element.onclick = function (e) {
                e.preventDefault();
                const form = document.getElementById('frm-productDetail-productQuestionForm-form');
                if (Nette.validateForm(form)) {
                    grecaptcha.execute(l);
                }
            }
        }
    }

    static submitQuestion() {
        const form = document.getElementById('frm-productDetail-productQuestionForm-form');
        if (form && Nette.validateForm(form[0])) {
            form.submit();
        }
    }
}
